module.exports = __webpack_public_path__ + "img/shapebg_intro_m.0019f919.svg";